var SiteSettingsData = React.createContext({});
export var SiteSettingsDataProvider = SiteSettingsData.Provider;
export var SiteSettingsDataConsumer = SiteSettingsData.Consumer;
export default SiteSettingsData;